/* eslint-disable import/order */
// User-related logics
import activity from './activity'
import alert from './alert'
import alertGroup from './alertGroup'
import alertLevel from './alertLevel'
import alertTopic from './alertTopic'
import appUser from './appUser'
import appVersion from './appVersion'
import boVersion from './boVersion'
import cixiReferent from './cixiReferent'
import company from './company'
import companyCategory from './companyCategory'
import companyPerLink from './companyPerLink'
import companyRole from './companyRole'
import companyVehicleBrandLink from './companyVehicleBrandLink'
import conditionalFeature from './conditionalFeature'
import country from './country'
import currency from './currency'
import dataMapping from './dataMapping'
import dateTimeFormat from './dateTimeFormat'
import serviceCenterAdmin from './serviceCenterAdmin'
import role from './role'
import user from './user'
import rider from './rider'
import rolesConfiguration from './rolesConfiguration'
import portalUser from './portalUser'
import helpDesk from './helpDesk'
import keySetting from './keySetting'

// System configuration logics
import systemConfig from './systemConfig'
import language from './language'
import timezone from './timezone'

// Notification and alert logics
import notificationTemplateContent from './notificationTemplateContent'
import notificationRequest from './notificationRequest'
import notificationTemplate from './notificationTemplate'
import notificationTemplateTech from './notificationTemplateTech'
import platformTech from './platformTech'
import platformPageTech from './platformPageTech'
import groupAlertField from './groupAlertField'

// Showcase-related logics
import showcaseStory from './showcaseStory'
import showcasePrivacyPolicy from './showcasePrivacyPolicy'
import showcaseContactLog from './showcaseContactLog'
import showcaseAnonymizeVisitor from './showcaseAnonymizeVisitor'
import faq from './faq'
import mostFrequentQuestion from './mostFrequentQuestion'
import scwPatent from './scwPatent'

// Miscellaneous logics
import storage from './storage'
import labels from './label'
import message from './message'
import mailTemplate from './mailTemplate'
import messageAfterConnection from './messageAfterConnection'
import uploadMedia from './uploadMedia'
import portal from './portal'
import section from './section'
import excludedDomain from './excludedDomain'

// Logging and monitoring logics
import logMail from './logMail'
import logRoutine from './logRoutine'
import logSwitchTo from './logSwitchTo'
import keyUsageSystemLog from './keyUsageSystemLog'
import usageSystemLog from './usageSystemLog'
import persPackage from './persPackage'
import persIOTMessage from './persIOTMessage'
import configurationPersComn from './configurationPersComn'

// Vehicle-related logics
import vehicle from './vehicle'
import vehicleBrand from './vehicleBrand'
import vehicleElectronicKey from './vehicleElectronicKey'
import vehicleModel from './vehicleModel'
import electronicKey from './electronicKey'
import electronicKeyModel from './electronicKeyModel'
import vehiclePer from './vehiclePer'
import vehicleType from './vehicleType'
import modelPer from './modelPer'
import subscriptionElectronicKey from './subscriptionElectronicKey'
import sharing from './sharing'
import per from './per'
import firmwareCategory from './firmwareCategory'
import firmwareVersionPers from './firmwareVersionPers'
import kitConfigurationVersionPers from './kitConfigurationVersionPers'
import kitUpdatePers from './kitUpdatePers'

// Company and activity logics
import subscription from './subscription'

// Odoo logics
import odooSynchronization from './odooSynchronization'
import dashboard from './dashboard'
import configPerTemplate from './configPerTemplate'
import cardMarketPlace from './cardMarketPlace'

// Partner API Key logics
import partnerAPIKey from './partnerAPIKey'

export default {
  commons: [
    // User-related logics
    ...rider,
    ...user,
    ...appUser,
    ...role,
    ...rolesConfiguration,
    ...serviceCenterAdmin,
    ...portalUser,

    // System configuration logics
    ...systemConfig,
    ...dateTimeFormat,
    ...language,
    ...timezone,
    ...conditionalFeature,

    // Logging and monitoring logics
    ...logMail,
    ...logRoutine,
    ...logSwitchTo,
    ...keyUsageSystemLog,
    ...usageSystemLog,
    ...persPackage,
    ...persIOTMessage,
    ...configurationPersComn,
    ...helpDesk,
    ...keySetting,

    // Notification and alert logics
    ...notificationTemplateContent,
    ...notificationRequest,
    ...notificationTemplate,
    ...notificationTemplateTech,
    ...platformTech,
    ...platformPageTech,
    ...alert,
    ...alertGroup,
    ...alertLevel,
    ...alertTopic,
    ...groupAlertField,

    // Showcase-related logics
    ...showcaseStory,
    ...showcasePrivacyPolicy,
    ...showcaseContactLog,
    ...showcaseAnonymizeVisitor,
    ...cardMarketPlace,
    ...faq,
    ...mostFrequentQuestion,
    ...scwPatent,

    // Miscellaneous logics
    ...storage,
    ...country,
    ...currency,
    ...labels,
    ...message,
    ...mailTemplate,
    ...messageAfterConnection,
    ...uploadMedia,
    ...portal,
    ...appVersion,
    ...boVersion,
    ...section,
    ...excludedDomain,

    // odoo logics
    ...dataMapping,
    ...odooSynchronization
  ],
  relatedToVehicles: [
    // Vehicle-related logics
    ...vehicle,
    ...vehicleModel,
    ...vehicleBrand,
    ...vehicleElectronicKey,
    ...electronicKey,
    ...electronicKeyModel,
    ...vehicleType,
    ...companyVehicleBrandLink,
    ...modelPer,
    ...subscriptionElectronicKey,
    ...sharing,
    ...vehiclePer,
    ...per,
    ...firmwareCategory,
    ...firmwareVersionPers,
    ...kitConfigurationVersionPers,
    ...kitUpdatePers,
    ...configPerTemplate,

    // Company and activity logics
    ...company,
    ...companyCategory,
    ...companyRole,
    ...companyPerLink,
    ...activity,
    ...subscription,
    ...cixiReferent,
    ...dashboard,

    // Partner API Key logics
    ...partnerAPIKey
  ]
}
